import { useState } from "react";
import CardModal from "./CardModal";
import {
  CardWrapper,
  CardInfoWrapper,
  ProfileImg,
  Name,
  Title,
  Email,
  Message,
  Company,
  OpenButton,
} from "./style";

const DEAFULT_IMAGE = `${process.env.PUBLIC_URL}/images/default.jpg`;

const Card = (props) => {
  const { data } = props;
  const { name, company, title, email, message, theme, filePath } = data;
  const imgPath = filePath || DEAFULT_IMAGE;

  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {isOpen && <CardModal data={data} setIsOpen={setIsOpen} />}

      <CardWrapper cardTheme={theme}>
        <OpenButton color={theme} onClick={() => setIsOpen(true)}>
          카드 다운로드
        </OpenButton>
        <ProfileImg src={imgPath} alt="profile" />
        <CardInfoWrapper>
          <Name>{name}</Name>
          <Company>{company}</Company>
          <hr />
          <Title>{title}</Title>
          <Email>{email}</Email>
          <Message>{message}</Message>
        </CardInfoWrapper>
      </CardWrapper>
    </>
  );
};

export default Card;
